import { ProductEditPage } from "./ProductEditPage";

export function ProductionProductEditPage() {
  return <ProductEditPage catalogMode="production" />;
}
